module.exports = __webpack_public_path__ + "static/img/1.0803cfc.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/5/1.png
// module id = 245
// module chunks = 0